import React from "react";
import { CircularProgress } from "@mui/material";

export function createLoadingAutocompleteSlotProps(
  loading,
  params,
  { spinnerSize = 18, startAdornment } = {}
) {
  return {
    input: {
      ...params.InputProps,
      ...(startAdornment ? { startAdornment } : {}),
      endAdornment: (
        <>
          {loading ? <CircularProgress color="inherit" size={spinnerSize} /> : null}
          {params.InputProps.endAdornment}
        </>
      ),
    },
  };
}
